import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './DummyBanner.module.scss';

function DummyBanner(props) {
  return (
    <div styleName={classNames('dummy', { mobile: props.isMobile })}>
      <div styleName="fixed-banner">
        This is a preview with dummy data
      </div>
    </div>
  );
}

DummyBanner.propTypes = {
  isMobile: PropTypes.bool,
};

export default DummyBanner;